import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { FloatLabel } from 'primereact/floatlabel';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { propTypes } from 'react-bootstrap/esm/Image';


export default function ProductCombo(props) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [item, setItem] = useState(props.value);
    const [extraParameters, setExtraParameters] = useState({});

    useEffect(() => {
        setLoading(true);
        var params = {param1:"1", param2:"", param3:"", param4:"", param5:""};
        var url = config.Server+`/basic/product-prices/list`;
        axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                for(var i=0;i<response.products.length;i++){
                    if(props.value)
                        if(props.value != null)
                            if(props.value.id == response.products[i].id) {
                                setItem(response.products[i]);
                                if(props.onChange){
                                    props.onChange({product:response.products[i], parameters:response.extraParameters});
                                }
                            }

                    response.products[i]["title"] = response.products[i].productType.title;
                }
                setItems(response.products);
                setExtraParameters(response.extraParameters);
                setLoading(false);
            }
            else{
                console.log("error is>", response.message)
            }
        })
        .catch(error => {
            console.log("error is>", error)
        });
    }, []);
    const getItem = function(items, id){
        if(items == null) return null;
        for(var i=0;i<items.length;i++){
            if(items[i].product.id == id) return items[i];
        }
        return null;
    }

    const onItemChanged = function (ii){
        if(!ii) ii = null;
        if(props.onChange){
            props.onChange(ii);
        }
    }


    return(
        <>
        {
            <>
            <Row style={{marginTop:"20px"}}>
                <Col>
                    <div className="card flex justify-content-center">
                        <FloatLabel className="w-full md:w-14rem">
                            <Dropdown inputId="cmb" value={item} onChange={(e) => {setItem(e.value); onItemChanged({product:e.value, parameters:extraParameters});}} options={items} optionLabel="title" className="w-full rtl-dropdown" 
                             checkmark={true} highlightOnSelect={true} filter showClear  style={{width:"100%"}} loading={loading} scrollHeight="350px"    
                            />
                            <label htmlFor="cmb">محصول</label>
                        </FloatLabel>
                    </div>
                    
                </Col>
            </Row>
            </>
        }
        </>
    )
}